import { useEffect } from 'react';
import { useClockTick, usePracticeContext } from '../../contexts';
export function useAutoStopPractice() {
    const { clock, evaluator: { timing } } = usePracticeContext();
    return useAutoStop(clock, timing, true);
}
export function useAutoStop(clock, timing, enabled) {
    const clockTick = useClockTick();
    useEffect(() => {
        const isLast = timing.endTick != null && clockTick.absTick >= timing.endTick;
        if (isLast && enabled) {
            clock.end();
        }
        return () => { };
    }, [clock, clockTick, enabled, timing]);
}
//# sourceMappingURL=useAutoStopPractice.js.map